import { laptopMaxXL, tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const ContactContainer = styled.div`
  background-color: #f9d8cd;
  padding: 100px 15px;

  @media (${tabletMax}) {
    padding: 60px 15px;
  }
`;

export const ContactContent = styled.div`
  width: 100%;
  max-width: 1260px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 30px;

  h2 {
    width: 660px;
    font-size: 60px;
    color: ${({ theme }) => theme.textDark};

    @media (${laptopMaxXL}) {
      font-size: 45px;
      width: 500px;
    }
  }

  @media (${tabletMax}) {
    flex-direction: column;
    padding: 0;

    h2 {
      width: 100%;
      font-size: 32px;
      text-align: center;
      margin-bottom: 30px;
    }
  }
`;

export const ContactBox = styled.div`
  background: ${(props) => props.theme.background};
  padding: 30px 40px;
  border-radius: 6px;
  width: 440px;
  margin-left: 30px;

  h4 {
    color: ${(props) => props.theme.textDark};
    text-align: center;
    font-size: 18px;
  }

  h6 {
    color: ${(props) => props.theme.textDark};
    text-align: center;
    font-size: 16px;
    margin-top: 15px;
  }

  @media (${tabletMax}) {
    width: 100%;
    margin-left: 0px;
    padding: 30px 15px;
  }
`;
